import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Position, IPosition} from '../../shared/model/position.model';
import {PositionService} from './position.service';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Organization} from "../../shared/model/organization.model";


@Component({
  selector: 'app-position-update',
  templateUrl: './position-update.component.html'
})
export class PositionUpdateComponent implements OnInit {
  position: IPosition = new Position();
  isSaving: boolean;
  @Input() positionEdit;

  constructor(protected positionService: PositionService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.isSaving = false;
// alert(' in init ==' + this.positionEdit);
    if (this.positionEdit) {
      this.positionService.find(this.positionEdit).subscribe(
        (res: HttpResponse<IPosition>) => {
          this.position = res.body;
          // alert(this.position);
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }

    // this.activatedRoute.data.subscribe(({position}) => {
    //   this.position = position;
    // });
  }


  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  save() {
    this.isSaving = true;
    // this.position.organization = new Organization(1);

    if (this.position.id !== undefined) {
      this.subscribeToSaveResponse(this.positionService.update(this.position));
    } else {
      this.subscribeToSaveResponse(this.positionService.create(this.position));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IPosition>>) {
    result.subscribe((res: HttpResponse<IPosition>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss('cancel');

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
